import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.5112 4.1511C13.5224 2.28205 10.4739 2.28297 8.48609 4.15385C6.44233 6.07738 6.61141 9.25631 8.45396 11.214C10.3775 13.2578 13.5564 13.0887 15.5141 11.2462C17.537 9.34224 17.5142 6.1563 15.5332 4.17241L15.5223 4.1617L15.5112 4.1511ZM14.4778 5.23837C13.0665 3.91796 10.9226 3.92055 9.51413 5.24615C8.15789 6.52262 8.18881 8.74369 9.54626 10.186C10.8227 11.5422 13.0438 11.5113 14.4861 10.1538C15.8596 8.86108 15.886 6.655 14.4778 5.23837Z"
    }, null, -1),
    _createElementVNode("path", { d: "M8.5 15.75C6.41421 15.75 4.75 17.4142 4.75 19.5C4.75 19.9142 4.41421 20.25 4 20.25C3.58579 20.25 3.25 19.9142 3.25 19.5C3.25 16.5858 5.58579 14.25 8.5 14.25H11.1C11.5142 14.25 11.85 14.5858 11.85 15C11.85 15.4142 11.5142 15.75 11.1 15.75H8.5Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.3303 14.2697C18.6374 13.5768 17.5626 13.5768 16.8697 14.2697L13.4697 17.6697C13.329 17.8103 13.25 18.0011 13.25 18.2V20.5C13.25 20.9142 13.5858 21.25 14 21.25H16.3C16.4989 21.25 16.6897 21.171 16.8303 21.0303L20.2303 17.6303C20.9232 16.9374 20.9232 15.8626 20.2303 15.1697L19.3303 14.2697ZM15.9893 19.75H14.75V18.5107L17.9303 15.3303C17.9942 15.2665 18.0552 15.25 18.1 15.25C18.1448 15.25 18.2058 15.2665 18.2697 15.3303L19.1697 16.2303C19.2335 16.2942 19.25 16.3552 19.25 16.4C19.25 16.4448 19.2335 16.5058 19.1697 16.5697L15.9893 19.75Z"
    }, null, -1)
  ])))
}
export default { render: render }